__turbopack_context__.v({
  "controls": "CatalogueFiltersModal-module__Ciromq__controls",
  "main": "CatalogueFiltersModal-module__Ciromq__main",
});
